module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik05LjY5MDU4IDE4LjY4OUw4LjMxMTcyIDE3LjMxMDFMMTMuNjIyMyAxMS45OTk1TDguMzExNzIgNi42ODg5Nkw5LjY5MDU4IDUuMzEwMTFMMTYuMzggMTEuOTk5NUw5LjY5MDU4IDE4LjY4OVoiIGZpbGw9ImJsYWNrIiBmaWxsLW9wYWNpdHk9IjAuOSIvPg0KPC9zdmc+DQo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/classroomObservation/right.svg
// module id = Oq/7
// module chunks = 4